"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentField = AttachmentField;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ActionModal = require("../../ActionModal.styles");

var _ImagePreview = require("../../../Action/components/ImagePreview");

var _store = require("../../../../redux/store");

var _uploadAttachment = require("./lib/uploadAttachment");

var _AddFile = require("../AddFile");

/* eslint-disable no-eq-null */
// TODO: Move to sibling
// TODO: Move to sibling elements
const AttachGroup = _styledComponents.default.div`
  display: grid;
  gap: ${_blocks.spacing.tight};
`;

function AttachmentField({
  actionKey,
  value,
  onSave
}) {
  const userId = (0, _store.useAppSelector)(state => state.auth.user.forgeId);
  const projects = (0, _store.useAppSelector)(state => {
    var _state$auth$user$port, _state$auth$user$port2;

    return Object.values((_state$auth$user$port = (_state$auth$user$port2 = state.auth.user.portfolio) === null || _state$auth$user$port2 === void 0 ? void 0 : _state$auth$user$port2.projects) !== null && _state$auth$user$port !== void 0 ? _state$auth$user$port : {});
  });
  const [orgKey, actionId] = actionKey.split('-');
  const project = projects.find(p => p.jira_key === orgKey);
  const [attachmentPath, setAttachmentPath] = (0, _react.useState)(value);
  const [attachment, setAttachment] = (0, _react.useState)();
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isEditing, setIsEditing] = (0, _react.useState)(false);

  const toggleEditing = () => {
    setIsEditing(prev => !prev);
  };

  const handleReset = () => {
    setAttachment(undefined);
  };

  const removeAttachment = () => {
    setAttachment(undefined);
    setAttachmentPath(undefined);
    setIsEditing(false); // Legacy support for removing attachments via old jira-style endpoints

    onSave('');
  };

  const handleChange = event => {
    var _event$currentTarget$;

    if (event.currentTarget.files == null) return;
    setAttachment((_event$currentTarget$ = event.currentTarget.files) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$[0]);
  };

  const handleSave = () => {
    if (attachment == null || project == null || userId == null) return;
    setIsLoading(true);
    (0, _uploadAttachment.uploadAttachment)({
      organisationId: project.forge_id,
      actionId: Number(actionId),
      userId,
      file: attachment
    }).then(res => {
      // After the attachment has uploaded set the attachment path to local
      // state to mimic the old behaviour of the attachment field
      // The server will handle the persistence of the attachment to the
      // screenshot_link field
      setAttachmentPath(`/v1/attachments/${res.id}/blob`);
    }).then(toggleEditing).catch(console.error).finally(() => {
      setAttachment(undefined);
      setIsLoading(false);
      setIsEditing(false);
    });
  }; // If there is an attachment, and it's not changing


  if (!isEditing && attachmentPath != null) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ActionModal.SubduedLabel, null, _core.i18n._({
      id: 'inline_edit_action.screenshot',
      message: `Screenshot`
    })), /*#__PURE__*/_react.default.createElement(_ImagePreview.ImagePreview, {
      onRemove: removeAttachment,
      src: `/api${attachmentPath}`
    }), /*#__PURE__*/_react.default.createElement(_blocks.Body, null, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
      wafer: true,
      onClick: toggleEditing
    }, _core.i18n._({
      id: 'inline_edit_action.attach_new',
      message: `Attach new`
    }))));
  } // If there is no attachment


  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ActionModal.SubduedLabel, null, _core.i18n._({
    id: 'inline_edit_action.screenshot',
    message: `Screenshot`
  })), /*#__PURE__*/_react.default.createElement(AttachGroup, null, /*#__PURE__*/_react.default.createElement(_AddFile.AddFile, {
    id: "EditScreenshot",
    label: _core.i18n._({
      id: 'inline_edit_action.attach',
      message: 'Attach file'
    }),
    onChange: handleChange,
    fileName: attachment === null || attachment === void 0 ? void 0 : attachment.name,
    onCancel: handleReset
  }), attachment != null && /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
    extraTight: true
  }, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
    wafer: true,
    onClick: handleSave,
    primary: true,
    disabled: isLoading
  }, _core.i18n._({
    id: 'inline_edit_action.upload_attachment',
    message: 'Upload'
  })), /*#__PURE__*/_react.default.createElement(_blocks.Button, {
    wafer: true,
    onClick: toggleEditing
  }, _core.i18n._({
    id: 'inline_edit_action.cancel_attachment',
    message: 'Cancel'
  })))));
}